import { jsx as a } from "@emotion/react/jsx-runtime";
import o, { dialogClasses as t } from "@mui/material/Dialog";
import i, { dialogActionsClasses as l } from "@mui/material/DialogActions";
import e, { dialogContentClasses as n } from "@mui/material/DialogContent";
import g, { dialogContentTextClasses as C } from "@mui/material/DialogContentText";
import r, { dialogTitleClasses as d } from "@mui/material/DialogTitle";
const N = t, c = ({ ...s }) => /* @__PURE__ */ a(o, { ...s });
c.displayName = "Dialog";
const $ = l, m = ({ ...s }) => /* @__PURE__ */ a(i, { ...s });
m.displayName = "DialogActions";
const b = n, D = ({ ...s }) => /* @__PURE__ */ a(e, { ...s });
D.displayName = "DialogContent";
const h = C, p = ({ ...s }) => /* @__PURE__ */ a(g, { ...s });
p.displayName = "DialogContentText";
const j = d, T = ({ ...s }) => /* @__PURE__ */ a(r, { ...s });
T.displayName = "DialogTitle";
export {
  c as D,
  $ as a,
  m as b,
  b as c,
  N as d,
  D as e,
  h as f,
  p as g,
  j as h,
  T as i
};
